
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.2 9.4H5.8v3.15a.44.44 0 01-.45.45h-.88a.46.46 0 01-.47-.45v-8.1A.46.46 0 014.47 4h.88a.44.44 0 01.45.45V7.6h4.4V4.45a.44.44 0 01.45-.45h.88a.46.46 0 01.47.45v8.1a.46.46 0 01-.47.45h-.88a.44.44 0 01-.45-.45zM2 9.4H1V7.6h1V6.45A.46.46 0 012.47 6h.46a.46.46 0 01.47.45v4.1a.46.46 0 01-.47.45h-.46a.46.46 0 01-.47-.45zm12-1.8h1v1.8h-1v1.15a.46.46 0 01-.47.45h-.46a.46.46 0 01-.47-.45v-4.1a.46.46 0 01.47-.45h.46a.46.46 0 01.47.45z"}})])
          )
        }
      }
    